var map = {
	"./close-w.png": "Y/nD",
	"./course.png": "8QRr",
	"./explogo.jpg": "fbEm",
	"./facebook.png": "xKEu",
	"./faculty.png": "Xeg2",
	"./flag.png": "ET/4",
	"./gg_logo.png": "nG//",
	"./gg_title_logo.png": "Xdxr",
	"./hamburger.png": "1BnE",
	"./insta_exp.png": "KNq3",
	"./linkedin_exp.png": "c0vh",
	"./pattern_card.png": "ma9C",
	"./quotes.png": "an/i",
	"./syllabus.png": "3pLb",
	"./tweet_exp.png": "wqto",
	"./web.png": "GhgL",
	"./yayyyy.png": "hzmU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pTVF";